import { DEPARTMENT_BASE_PATH } from '@pages/departments/config';

/**
 * Canonical paths of the planning section
 * (`/departments/:departmentId/planning`, see `src/pages/planning`).
 *
 * The planner tabs themselves (weekend, holidays, paid-leave,
 * vacation, absence, absence-prediction, requests) are defined by the
 * planning feature (see `@features/planning`).
 */
export const PLANNING_PATHS = {
    /** Planner tabs; redirects to the default tab. */
    planning: (departmentId: string): string =>
        `${DEPARTMENT_BASE_PATH}/${departmentId}/planning`,
    /** Single planner tab. */
    planningTab: (departmentId: string, tab: string): string =>
        `${DEPARTMENT_BASE_PATH}/${departmentId}/planning/${tab}`,
} as const;
